<template>
<div :class="['modal', {'is-active': true}]" v-if="product">
    <div class="modal-background"></div>
    <div class="modal-content">
        <ProductPreview class="bg-white" :mini_data="product" />
    </div>
    <button @click.prevent="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import ProductPreview from './ProductPreview';
export default {
    name        :   'ProductPreviewModal',
    components  :   { ProductPreview },
    data()
    {
        return {
            product    :   null
        }
    },
    created()
    {
        this.$bus.$on('onProductPreview', (product) => {
            this.product   =   product;
        });
    },
    watch   :   {
        product(nv, ov)
        {
            if (nv) {
                $('html').addClass('is-locked');
            } else {
                $('html').removeClass('is-locked');
            }
        }
    },
    methods :   {
        close()
        {
            this.product   =   null;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ProductPreviewModal.vue